// This is to display full chart in window_view. This is adapted from index.js in options 
// Highcharts api docs https://api.highcharts.com/highcharts/chart.events.selection

/* eslint-disable array-callback-return, eqeqeq */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import MOV from "./body_movement";
import Y_DIST from "./chest_displacement";
import SLP_STGS from "./sleep_stages";
import sleep_stages_probablity from "./sleep_stages_probablity";
import HR from "./heart_rate";
import HRV from "./heart_rate_variability";
import BR from "./breathing_rate";
import BRV from "./breathing_rate_variability";
import SPO2 from "./spo2";
import PR from "./pulse_rate";
import I from "./i_kpi";
import Q from "./q_kpi";
import IQ from "./iq_kpi";
import SA from "./sa_kpi";
import TB from "./tb_kpi";
import SPO2_PSG from "./spo2_psg";
import NC_PSG from "./nasal_cannula";
import ABD_PSG from "./abdomen";
import THRX_PSG from "./thorax";

dayjs.extend(utc);

const options = {
    MOV,
    Y_DIST,
    SLP_STGS,
    sleep_stages_probablity,
    HR,
    HRV,
    BR,
    BRV,
    SPO2,
    PR,
    I,
    Q,
    IQ,
    SA,
    TB,
    NC_PSG,
    SPO2_PSG,
    THRX_PSG,
    ABD_PSG
};

export const get_full_chart_options = ({
    kpi_id,
    analytics,
    sqbAnalytics,
    syncExtremes,
    height,
    zoom_type,
    // set_annotate,
    // set_annotate_range,
    // mixed_annotations,
    annotation_flags,
    // toggleGraphAnnotation,
    // annotation_colours,
    customTimeRange,
    // showEditAnnotationPopup,
    // setCustomTimeRange,
    show_artifects_flag,
}) => {
    const { dataset, ts } = analytics;

    let xAxis;
    if(kpi_id === 'IQ'){
        let i_min, i_max, q_min, q_max
        try {
            i_min = Number(analytics.I.ts[0]) * 1000
            i_max = Number(analytics.I.ts[analytics.I.ts.length - 1]) * 1000
            q_min = Number(analytics.Q.ts[0]) * 1000
            q_max = Number(analytics.Q.ts[analytics.Q.ts.length - 1]) * 1000
        } catch (error) {
            console.log('ERROR MIN AND MAX  ', error)
        }
        xAxis = {
            min: i_min < q_min ? i_min : q_min,
            max: i_max > q_max ? i_max : q_max,
        }
    } else {
            xAxis = {
                min: Number(ts[0]) * 1000,
                max: Number(ts[ts.length - 1]) * 1000,
            }
    }

    let opt;
    if(kpi_id === 'IQ'){
        const data = {
            I: analytics.I.dataset.map((d, i) => {
                const t = Number(analytics.I.ts[i]) * 1000;
                return [t, d === null ? null : Number(d)];
            }),
            Q: analytics.Q.dataset.map((d, i) => {
                const t = Number(analytics.I.ts[i]) * 1000;
                return [t, d === null ? null : Number(d)];
            }),
        }

        opt = options[kpi_id]({ data });
    } else {
        const data = dataset.map((d, i) => {
            const t = Number(ts[i]) * 1000;
            if (kpi_id === "STAGES") {
                if (d == "-1" || d == "-2") {
                    return [t, null];
                }
            }
            
            if (kpi_id === "SA" || kpi_id === "TB") {
                if (d == null) {
                    return [t, null];
                }
            }
            if(kpi_id === "NC_PSG" || kpi_id === "THRX_PSG" || kpi_id === "ABD_PSG" || kpi_id === "SPO2_PSG"){
                if (d == null) {
                    return [t, null];
                }
            }
            return [t, d === null ? null : Number(d)];
        });

        opt = options[kpi_id]({ data });
    }

    if (show_artifects_flag && sqbAnalytics && (["Y_DIST", "BR", "HR"].indexOf(kpi_id) > -1)) {
        let minVal = -0.4;
        let maxVal = 0.4;
        if (kpi_id !== "Y_DIST") {

            minVal = Number((Math.min.apply(null, analytics.dataset)).toFixed(2));
            maxVal = Number((Math.max.apply(null, analytics.dataset)).toFixed(2));
        }

        const sqbData = sqbAnalytics.dataset.map((d, i) => {
            const t = Number(sqbAnalytics.ts[i]) * 1000;
            let ds;
            if (kpi_id !== "Y_DIST") {
                ds = Math.ceil(minVal + (maxVal - minVal) * (d === 1 ? 0 : 1));
            } else {
                ds = minVal + (maxVal - minVal) * (d === 1 ? 0 : 1);
            }
            return [t, minVal, Number(ds)];
        });


        const sqbSeries = {
            type: 'arearange',
            step: true,
            name: "Signal Quality Binary",
            showInLegend: false,
            color: "rgb(235 236 251)",
            data: sqbData,
            lineColor: "lightblue"
        };

        opt.series[0] = { ...opt.series[0], type: opt.chart.type };
        opt.series[1] = sqbSeries;

        opt.yAxis = [
            opt.yAxis, {
                title: {
                    enabled: false
                },
                labels: {
                    enabled: false
                },
            }
        ];
    }

    let tickAmount = 3;
    if (["MOV","SA","TB"].indexOf(kpi_id) > -1) {
        tickAmount = 2;
    }
    if (["HR"].indexOf(kpi_id) > -1 || ["BR"].indexOf(kpi_id) > -1) {
        if (!show_artifects_flag) {
            opt.yAxis.min = 0
        }
        else{
            opt.yAxis.min = 0 
        }
    }
    opt = {
        ...opt,
        title: {
            ...opt.title,
            id: kpi_id,
        },
        xAxis: {
            ...opt.xAxis,
            ...xAxis,
            scrollbar: {
                enabled: false
            },
            startOnTick: false,
            endOnTick: false,
            showLastLabel: true,
            plotBands: [{
                from: 0,
                to: 0
            }],
            events: {
                // setExtremes: syncExtremes, 
                // afterSetExtremes: function () {
                //     console.log(this, "this")
                // },
            },
        },
        yAxis: {
            ...opt.yAxis,
            opposite: false,
            tickAmount: tickAmount,
            startOnTick: true,
            endOnTick: true,
            showLastLabel: true,
            labels: {
                ...opt.yAxis.labels,
                y: 5,
            },
        },
        chart: {
            ...opt.chart,
            zoomType: zoom_type,
            selection: true,
            height,
            events: {
                ...opt.chart.events,
                redraw: function () {
                },
                load: function (e) {
                    if ((customTimeRange && customTimeRange.length === 2) || (annotation_flags && Object.values(annotation_flags).length > 0)) {
                        // let axis = e.target.xAxis[0];
                        // axis.setExtremes(min, max);
                    }


                    let containerHeight = window.innerHeight - 200;
                    let chartElements = document.querySelectorAll('.chart-block');
                    let expChartElements = document.querySelectorAll('.chart-block.expanded');
                    let chartHeight;

                    if (expChartElements && expChartElements.length) {
                        if (expChartElements.length === 1) {
                            chartHeight = containerHeight - 10
                        } else if (expChartElements.length === 2) {
                            chartHeight = (containerHeight - 20) / 2;
                        } else if (expChartElements.length === 3) {
                            chartHeight = (containerHeight - 30) / 3;
                        } else if (expChartElements.length === 4 || expChartElements.length >= 4) {
                            chartHeight = (containerHeight - 40) / 4;
                        }
                    } else {
                        if (chartElements.length > 2) {
                            chartHeight = (containerHeight - 20) / 2;
                        } else {
                            chartHeight = containerHeight - 10;
                        }
                    }

                    for (let i = 0; i < chartElements.length; i++) {
                        chartElements[i].style.height = chartHeight + 'px';
                    }

                    if (e.target) {
                        e.target.reflow();
                    }
                },

                selection: function (e) {
                    if(e.xAxis) {
                        e.target.xAxis[0].removePlotBand('wv-full-chart-plot-band');
                        e.target.xAxis[0].addPlotBand({
                            from: e.xAxis[0].min,
                            to: e.xAxis[0].max,
                            id: 'wv-full-chart-plot-band'
                        });
                        syncExtremes(e.xAxis[0]); 
                    }
                    return false;
                //     max = e.target.xAxis[0].max;
                //     min = e.target.xAxis[0].min;
                //     if (e.xAxis) {
                //         set_annotate_range([moment.utc(Math.round(e.xAxis[0].min)).format("YYYY-MM-DD HH:mm:ss"), moment.utc(Math.round(e.xAxis[0].max)).format("YYYY-MM-DD HH:mm:ss")]);
                //         if (annotation_flags[kpi_id]) {
                //             set_annotate(true);
                //             return false;
                //         }
                //         if (e.originale && e.originale.ctrlKey === true) {
                //             toggleGraphAnnotation(kpi_id);
                //             set_annotate(true);
                //             return false;
                //         }
                //         setCustomTimeRange([e.xAxis[0].max, e.xAxis[0].min]);
                //     }
                },
            },
            resetZoomButton: {
                theme: {
                    display: 'none'
                }
            }
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: false
        },
        tooltip: {
            ...opt.tooltip,
            formatter: function () {

                let {
                    dataMax = "-- : --",
                    dataMin = "-- : --",
                } = this.points[0].series;

                    const y = Math.floor(this.y * 100) / 100;
                    // console.log("y",y)
                    const x = dayjs.utc(this.x).format("hh:mm A, DD MMM");
                    if (typeof dataMax === "number") {
                        dataMax = Math.floor(dataMax * 100) / 100;
                    }
                    if (typeof dataMin === "number") {
                        dataMin = Math.floor(dataMin * 100) / 100;
                    }
                    return `<b>Value</b>: ${y} at ${x}`

            }
        },
        plotOptions: {
            ...opt.plotOptions,
            series: {
                events: {
                    click: function () {
                    }
                }
            }
        },
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 800
                },
                chartOptions: {
                    rangeSelector: {
                        inputEnabled: false,
                    }
                }
            }]
        },
        rangeSelector: {
            enabled: false,
        },
        scrollbar: {
            enabled: false
        },
    }


    return opt;
};

export default options;